<template>
  <div>
    <header-mx></header-mx>
    <section class="main">
      <div class="figuras interior">
        <div class="container video">
          <div
            class="row"
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="500"
          >
            <div class="col-12">
              <div class="row pt-2 pb-4 pt-lg-0 white">
                <div class="col-12 pb-4 text-center" v-if="cursos != null">
                  <span class="naranja fXG pb-4 d-block">
                    <strong>{{ cursos[index].titulo }}</strong>
                  </span>
                  <p class="fG pb-4">
                    En esta Master Class, {{ cursos[index].maestro }} nos enseña
                    a preparar {{ cursos[index].titulo }}.
                  </p>
                  <p class="fG pb-4">Puedes verla aquí:</p>
                </div>

                <div class="col-12 pb-3 fG" v-if="cursos != null">
                  <iframe
                    class="iframe"
                    :src="cursos[index].live"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>

                <div class="col-12" v-if="cursos != null">
                  <p class="fG" v-html="cursos[index].videotxt"></p>

                  <!-- <ul class="pl-4">
                    <li>Morbi accumsan tellus sed dui semper, nec facilisis sapien vulputate</li>
                    <li>Mauris ac neque elementum est rhoncus sodales sed id quam</li>
                    <li>Pellentesque vel neque cursus, tristique nulla in, eleifend erat</li>
                  </ul>-->
                </div>
              </div>

              <div class="row pb-2 objetivo">
                <div class="col-12 col-lg-8 offset-lg-2">
                  <div class="row">
                    <div class="col-12" v-if="cursos != null && cursos[index].ingredientes.length > 0">
                      <div class="row">
                        <div class="col-9 white">
                          <h2 class="naranja w-100 fXG">Ingredientes</h2>
                        </div>
                        <div class="col-3 naranja fG">Comprar</div>
                      </div>
                    </div>
                    <div class="col-12 pb-5 mb-5" v-if="cursos != null && cursos[index].ingredientes.length > 0">
                      <div
                        class="row"
                        v-for="(ingrediente, index) of cursos[index]
                          .ingredientes"
                        :key="index"
                      >
                        <div class="col-12" v-if="ingrediente.separador !== true">
                          <div class="row">
                            <div class="col-9 white fG">
                              {{ ingrediente.nombre }}
                            </div>
                            <div class="col-3">
                              <a :href="ingrediente.link" target="_blank">
                                <img
                                  src="../../assets/imgs/Carrito-white.png"
                                  alt="carrito"
                                />
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="col-12" v-else>
                          <div class="row">
                            <div class="col-12 naranja fG py-5">
                              {{ ingrediente.nombre }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 pb-5 mb-5">
                      <div class="row">
                        <div class="col-md-4 offset-md-0 col-6 offset-3 pb-5">
                          <a
                            href="https://super.walmart.com.mx/temporadas/maestros-de-la-parrilla/cat3700068"
                            target="_blank"
                          >
                            <img
                              class="img-fluid px-5"
                              src="../../assets/imgs/mdlp2021/walmart.png"
                              alt="walmart"
                            />
                          </a>
                        </div>
                        <div class="col-md-4 offset-md-0 col-6 offset-3 pb-5">
                          <a
                            href="https://www.superama.com.mx/micrositio/maestros-de-la-parrilla/"
                            target="_blank"
                          >
                            <img
                              class="img-fluid px-5"
                              src="../../assets/imgs/mdlp2021/superama.png"
                              alt="Academia Digital"
                            />
                          </a>
                        </div>
                        <div class="col-md-4 offset-md-0 col-6 offset-3 pb-5">
                          <a
                            href="https://www.superama.com.mx/micrositio/maestros-de-la-parrilla/"
                            target="_blank"
                          >
                            <img
                              class="img-fluid px-5"
                              src="../../assets/imgs/mdlp2021/walmart-express.png"
                              alt="walmart express"
                            />
                          </a>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 text-center py-5">
                      <router-link to="/videorecetas" class="btn btnazul"
                        >Regresar</router-link
                      >
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="col-12 pb-3">
                <div class="row">
                  <div class="col-12 text-center">
                    <a
                      href="https://www.superama.com.mx/micrositio/recetas-maestros-de-la-parrilla/"
                      class="d-none d-lg-block"
                      target="_blank"
                      @click="clickComprar()"
                    >
                      <img
                        class="img-fluid"
                        src="../../assets/imgs/banner_mdlp_desk.jpg"
                        alt="recetario"
                      />
                    </a>
                    <a
                      href="https://www.superama.com.mx/micrositio/recetas-maestros-de-la-parrilla/"
                      class="d-block d-lg-none"
                      target="_blank"
                      @click="clickComprar()"
                    >
                      <img
                        class="img-fluid"
                        src="../../assets/imgs/banner_mdlp_mobile.jpg"
                        alt="recetario"
                      />
                    </a>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <footer-mx></footer-mx>
    </section>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../../Components/Header.vue";
import Footer from "../../Components/Footer.vue";
import Vue from "vue";
// import Vue2TouchEvents from "vue2-touch-events";
// Vue.use(Vue2TouchEvents);
import { Carousel3d, Slide } from "vue-carousel-3d";

//Vue.use(Carousel3d);

export default {
  name: "AcademiaDigital",
  props: {
    msg: String,
  },
  data() {
    return {
      email: "",
      password: "",
      info: false,
      cursos: null,
      index: -1,
    };
  },
  mounted: function () {
    // Opción múltiple
    // relacionar columnas
    // eliminar el incorrecto
    // poner en orden varios elementos

    //this.$store.state.user = JSON.parse(this.$cookie.get("useracademiadigital"));
    this.$store.state.user = JSON.parse(
      localStorage.getItem("useracademiadigital")
    );
    AOS.init();
    this.cursos = this.$store.state.videorecetas;
    this.index = this.$route.params.id;
  },
  components: {
    "header-mx": Header,
    "footer-mx": Footer,
  },
  methods: {
    clickComprar() {
      this.$gtag.event("Click comprar", {
        event_category: "MDLP",
      });
    },
    clickRecetario() {
      this.$gtag.event("Descarga recetario", {
        event_category: "MDLP",
      });
    },
    toggleInfo() {
      this.info = !this.info;
    },
    onAfterSlideChange(index) {
      console.log(
        "@onAfterSlideChange Callback Triggered",
        "Slide Index " + index
      );
      this.index = index;
    },
    swipeHandler(direction) {
      console.log(direction); // May be left / right / top / bottom
    },
  },
};
</script>

